import React, { useEffect, useState } from 'react'

import { Helmet } from 'react-helmet'

import './pharmacy.css'
import { Link } from 'react-router-dom';

import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import zIndex from '@mui/material/styles/zIndex';
import { useCart } from '../contexts/CartContext';
import { Box } from '@mui/material';
import useIsMobile from '../hooks/useIsMobile';
import mobileEpharmacyTopPicture from '../assets/mobileEpharmacyTopPicture.png'
import closeIcon from '../assets/closeIcon.png'
import heroEpharmacy from '../assets/categories/EPHARMACY.png'
// import healixImage from '../../assets/Healix/Group 165112.png';
import healixImage from '../assets/Healix/healix animated_optimised.svg';
import imgBABY from '../assets/categories/BABY.png'
import imgHYGIENE from '../assets/categories/HYGIENE.png'
import imgWOMEN from '../assets/categories/WOMEN.png'
import imgSKIN from '../assets/categories/SKIN.png'
import imgBEAUTY from '../assets/categories/BEAUTY.png'
import imgVITAMINE from '../assets/categories/VITAMINE.png'
import imgSPORT from '../assets/categories/SPORT.png'
import imgOFFERS from '../assets/categories/OFFERS.png'
import imgOTC from '../assets/categories/OTC.png'
import Medicament from '../components/Medicaments';
import { ProductModal } from '../components/ProductModal';
import AddToCartButton from '../components/AddToCartButton';
import { ProductCard } from '../components/ProductCard';
import FilterModal from '../components/FilterModal/FilterModal';
import SearchSection from '../components/SearchBar/SearchSection'; // Import the new SearchSection component
import { dummyBlogs } from '../data/dummyblogs';
import ReactMarkdown from 'react-markdown';
import { baseUrl } from '../utils/config';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import axios from 'axios';
import DatabaseService from '../services/DatabaseService';

const Pharmacy = (props) => {
  const navigate = useNavigate();
  const [showCart, setShowCart] = useState(false);
  const { addToCart } = useCart();
  const location = useLocation();
  const [medicaments, setMedicaments] = useState([]);
  const [filteredMedicaments, setFilteredMedicaments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filters, setFilters] = useState({
    priceRange: [0, 1000],
    category: ''
  });

  const isMobile = useIsMobile();

  // Create axios instance with token interceptor
  const api = axios.create({ baseURL: baseUrl });
  api.interceptors.request.use((config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // const desktopCategories = [
  //   { src: '/external/vector1532-nde9.svg', label: 'Special Offers', },
  //   { src: '/external/plus1532-rgpa.svg', label: 'Otc Medicine', },
  //   { src: '/external/vector1532-gx.svg', label: 'Sport Wellness', },
  //   { src: '/external/vector1532-5vjq.svg', label: 'Vitamins', },
  //   { src: '/external/care1532-duc8.svg', label: 'Beauty & cosmetics', },
  //   { src: '/external/creamhealthskincosmeticbeauty1532-c7vj.svg', label: 'Skin Care', },
  //   { src: '/external/vector1532-14qp.svg', label: 'Women care', },
  //   { src: '/external/clean1532-tsv.svg', label: 'Hygiene care', },
  //   { src: '/external/baby1532-0tgp.svg', label: 'Baby care', }
  // ];

  // const mobileCategories = [
  //   { src: '/external/vector1532-nde9.svg', label: 'Special Offers',  },
  //   { src: '/external/plus1532-rgpa.svg', label: 'Otc Medicine', },
  //   { src: '/external/vector1532-gx.svg', label: 'Sport Wellness', },
  //   { src: '/external/care1532-duc8.svg', label: 'Beauty & cosmetics', },
  //   { src: '/external/creamhealthskincosmeticbeauty1532-c7vj.svg', label: 'Skin Care', },
  //   { src: '/external/clean1532-tsv.svg', label: 'Hygiene care', },
  // ];

  // const categoriesToRender = isMobile ? mobileCategories : desktopCategories;

  // Categories data from Medicaments
  // const categories = [
  //     { id: 1, title: "Sport Wellness" },
  //     { id: 2, title: "Beauty & Cosmetics" },
  //     { id: 3, title: "OTC Medicine" },
  //     { id: 4, title: "Special Offers" },
  //     { id: 5, title: "Vitamins" },
  //     { id: 6, title: "Skin Care" },
  //     { id: 7, title: "Women care" },
  //     { id: 8, title: "Hygiene care" },
  //     { id: 9, title: "Baby care" },
  //   ];

  const allCategories = [
    { id: 4, title: "Special Offers", src: imgOFFERS },
    { id: 3, title: "OTC Medicine", src: imgOTC },
    { id: 1, title: "Sport Wellness", src: imgSPORT },
    { id: 5, title: "Vitamins", src: imgVITAMINE },
    { id: 2, title: "Beauty & Cosmetics", src: imgBEAUTY },
    { id: 6, title: "Skin Care", src: imgSKIN },
    { id: 7, title: "Women care", src: imgWOMEN },
    { id: 8, title: "Hygiene care", src: imgHYGIENE },
    { id: 9, title: "Baby care", src: imgBABY },
  ];
  const filterCategories = allCategories.map(cat => cat.title);



  const mobileCategoryTitles = [
    "Special Offers",
    "OTC Medicine",
    "Sport Wellness",
    "Beauty & Cosmetics",
    "Skin Care",
    "Hygiene care",
  ];

  const categoriesToRender = isMobile
    ? allCategories.filter(cat => mobileCategoryTitles.includes(cat.title))
    : allCategories;




  const products = [
    {
      id: 1,
      name: 'NOVEXPERT',
      image: '/external/image131531-h718-300h.png',
      price: '95.380 TND',
      specialPrice: '60.380 TND',
      discountPercentage: '30%',
    },
    {
      id: 2,
      name: 'SVR',
      image: '/external/image131531-h718-300h.png',
      price: '95.380 TND',
      specialPrice: '',
      discountPercentage: '',
    },
    {
      id: 3,
      name: 'SVR',
      price: '95.380 TND',
      specialPrice: '',
      discountPercentage: '',
    },
    {
      id: 4,
      name: 'AVENE',
      image: '/external/svrampouleb3hydra30mlphotoroompngphotoroom11531-4ds-200w.png',
      price: '95.380 TND',
      specialPrice: '',
      discountPercentage: '',
    },
  ];
  const sportWellness = [
    {
      id: 1,
      name: 'MURIAC',
      image: '/external/MURIAC_LIGHTACT_BRIGHTENING_CLEANSING_FOAM_150ML.jpg',
      price: '38.650 TND',
      specialPrice: '',
      discountPercentage: '',
    },
    {
      id: 2,
      name: 'ACM',
      image: '/external/ACM_DEPIWHITE_ACTIVE_GEL_40ML.jpg',
      price: '97.970 TND',
      specialPrice: '',
      discountPercentage: '',
    },
    {
      id: 3,
      name: 'MURIAC',
      image: '/external/MURIAC_LIGHTACT_INTENSIVE_ANTI-DARK_SPOT_SERUM_30ML.jpg',
      price: '85.260 TND',
      specialPrice: '',
      discountPercentage: '',
    },
    {
      id: 4,
      name: 'ACM',
      image: '/external/MURIAC_LIGHTACT_SUNSCREEN_50+_50ML.jpg',
      price: '52.710 TND',
      specialPrice: '',
      discountPercentage: '',
    },
  ];

  // Initialize database service
  const databaseService = DatabaseService;

  // Fetch medicament data on component mount
  useEffect(() => {
    const getMedicaments = async () => {
      setLoading(true);
      try {
        // Use the database service - backend will handle location detection
        console.log("🌍 [LOCATION DEBUG] Fetching products with location-based filtering...");
        const products = await databaseService.getProducts();
        console.log("🌍 [LOCATION DEBUG] ✅ Successfully fetched products:", products.length, "products");
        console.log("🌍 [LOCATION DEBUG] 📊 Product details:", products.map(p => ({ 
          id: p.id, 
          name: p.name, 
          partner: p.partner_id 
        })));
        setMedicaments(products);
        setFilteredMedicaments(products);
        
        // Additional debug info
        console.log("🌍 [LOCATION DEBUG] 🎯 Location-based filtering is working! Products are filtered by your detected country.");
        console.log("🌍 [LOCATION DEBUG] 💡 Check backend logs to see detected country and filtering process.");
      } catch (error) {
        console.error("🌍 [LOCATION DEBUG] ❌ Error fetching medicaments:", error);
        // Fallback to original method if database service fails
        try {
          console.log("🌍 [LOCATION DEBUG] 🔄 Trying fallback method...");
          const response = await api.get('/products?skip=0&limit=16');
          setMedicaments(response.data.products);
          setFilteredMedicaments(response.data.products);
          console.log("🌍 [LOCATION DEBUG] ✅ Fallback successful:", response.data.products.length, "products");
        } catch (fallbackError) {
          console.error("🌍 [LOCATION DEBUG] ❌ Fallback also failed:", fallbackError);
        }
      } finally {
        setLoading(false);
      }
    };

    getMedicaments();
  }, []);

  // coming back from the signIn
  useEffect(() => {
    if (isAuthenticated()) {
      const postLoginRedirect = localStorage.getItem("postLoginRedirect");
      if (postLoginRedirect) {
        try {
          const postLoginRedirectObj = JSON.parse(postLoginRedirect);
          const chosenProduct = postLoginRedirectObj.product;

          addToCart(chosenProduct);
          localStorage.removeItem("postLoginRedirect");
          localStorage.removeItem("signInMessage");

        } catch (e) {
          console.error("Invalid saved survey state:", e);
        }
      }
    }

  }, []);

  const isAuthenticated = () => {
    return !!localStorage.getItem("userEmail"); // or whatever auth logic you use
  };

  const handleAddToCart = () => {
    setSelectedProduct(null);
  }

  // const handleCloseCart = () => {
  //   setShowCart(false);
  // };

  useEffect(() => {
    const email = localStorage.getItem("userEmail");
    console.log("Logged in user:", email);
  }, []);

  const handleAddToCartUnauthenticated = (product) => {
    const postLoginRedirect = {
      from: "EPharmacy",
      action: "addToCart",
      product: product
    };

    localStorage.setItem("postLoginRedirect", JSON.stringify(postLoginRedirect));
    localStorage.setItem("signInMessage", "Please sign in to add this product to your cart.");

    navigate("/signIn", {
      state: {
        from: location
      },
      replace: true,
    });
  };

  const handleDropdownProductSelect = (product) => {
    setSelectedProduct(product);
    setShowProductModal(true);
  };

  const handleCloseProductModal = () => {
    setShowProductModal(false);
  };

  const handleApplyFilters = (newFilters) => {
    setFilters(newFilters);
    // Filter the medicaments based on the new filters
    const filtered = medicaments.filter(medicament => {
      const price = parseFloat(medicament.price);
      const inPriceRange = price >= newFilters.priceRange[0] && price <= newFilters.priceRange[1];
      const inCategory = !newFilters.category || medicament.category === newFilters.category;
      return inPriceRange && inCategory;
    });
    setFilteredMedicaments(filtered);
  };

  // Add these helper functions before the return statement
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  // const getFirstSentence = (content) => {
  //   const firstSentence = content.split('.')[0];
  //   const trimmedSentence = firstSentence.length > 100 ? firstSentence.substring(0, 100) + '...' : firstSentence;
  //   return trimmedSentence;;
  // };

  const getFirstSentence = (content) => {
    const lines = content.split('\n').map(line => line.trim()).filter(Boolean);

    // Check if first line is an introduction (contains "Introduction" or similar)
    const isIntroduction = lines[0]?.toLowerCase().includes('introduction');

    // If there's an introduction, use the second line, otherwise use the first line
    const contentLine = isIntroduction ? (lines[1] || '') : (lines[0] || '');

    // Get first 20 words
    const words = contentLine.split(' ').slice(0, 20).join(' ');
    return words + '...';
  };

  const [showPartnerDialog, setShowPartnerDialog] = useState(false);
  useEffect(() => {
    console.log("showPartnerDialog:", showPartnerDialog);
  }, [showPartnerDialog]);

  const handleDialogClose = () => {
    setShowPartnerDialog(false);
  };

  return (


    <div >
      <Helmet>
        <title>Tachafy</title>
      </Helmet>
      {/* <Header /> */}

      {/* Coming Soon */}
      {/* {true && (
        <div className="coming-soon-overlay">
          <div className="coming-soon-text">Coming Soon</div>
        </div>
      )} */}
      {/* Epharmacy */}
      {/* <div class="parent-container"> // before coming soon,*/}
      <div class="pharmacy-pharmacy">
        {/* First Section */}
        <div class="firstSection">
          {/* <div className='heroImageWrapperMobile'>
            <img
              src={mobileEpharmacyTopPicture}
              alt="Hero"
              className='heroImageMobile'
            />
          </div> */}


          <div className="heroImageWrapper">
            <img
              src={heroEpharmacy}
              alt="Rectangle7061535"
              className="heroImage"
            />
            <div className="heroOverlay" />

            <div className="heroTextContainer">
              <span className="heroTitle">
                Get the care you need with ease
              </span>
              <span className="heroSubtitle">
                Shop your prescriptions and a wide range of health products online from our e-pharmacy, delivered to your doorstep.
              </span>
              <button
                className="heroShopButton"
                onClick={() => navigate('/listproduct/3')}
                style={{ backgroundColor: '#C37559', color: '#fff' }}
              >
                Shop Now
              </button>
            </div>
          </div>




          {/* Removed extra doctor image to keep hero as a single image box */}
        </div>

        {/* Second Section - Restore original static HTML and manually integrate functionality */}
        <div
          className="secondSection"
          style={{
            position: 'relative',
            width: isMobile ? '95%' : '50%',          
            maxWidth: isMobile ? '100%' : '600px',     
            margin: '0 auto',      
            right: 0,
            padding: isMobile ? '0 10px' : '0',
            boxSizing: 'border-box',
          }}
        >
          <SearchSection
            medicaments={medicaments}
            isMobile={isMobile}
            onProductSelect={handleDropdownProductSelect}
            onOpenFilterModal={() => setShowFilterModal(true)}
            filterModalOpen={showFilterModal}
            onApplyFilters={handleApplyFilters}
            filteredMedicaments={filteredMedicaments}
            activeFilters={filters}
          />
        </div>

        {/* third section */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            zIndex: 1,  // Makes sure it's on top of other elements if necessary
          }}
        >

          {/* title */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            // top: '150px',
          }}>
            <span className="smallTitleStyle">
              Our Categories
            </span>
            <span className="pharmacy-text108Custom">
              <span>
                Find everything you need
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>for your health in one place</span>
            </span>

          </div>

          {/* categories */}
          <div className="responsive-grid">
            {categoriesToRender.map((item) => (
              <div
                key={item.id}
                className="responsive-box"
                onClick={() => navigate('/listproduct/' + item.id)}
              >
                <img
                  src={item.src}
                  alt={item.title}
                  className={`category-icon ${isMobile && ['Special Offers', 'OTC Medicine', 'Skin Care'].includes(item.title) ? 'category-icon--small-mobile' : ''}`}
                />
                <label className="category-label">{item.title}</label>
              </div>
            ))}
          </div>

          {/* explore button */}
          {/* <div
            className="explore-button-categories"
          >
            <button className="responsive-button" style={{ backgroundColor: '#C37559', color: '#fff' }}>
              Explore all
            </button>
          </div> */}
        </div>

        {/* Our Special Offer */}
        <div
          style={{
            position: 'relative',
            zIndex: 10,
            textAlign: 'center',
            backgroundColor: 'rgba(245, 245, 245, 0.41)', // F5F5F5 with 41% opacity
            borderRadius: '30px',
            width: '90%',
            // padding: '40px',
            justifySelf: 'center'
          }}

        >
          <span className="pharmacy-text108Custom">Our Special Offers</span>

          <div
            className="product-grid"
          >
            {products.map((product) => (
              <div
                key={product.id}
                className="product-card"
                style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '360px' }}
              >
                {product.discountPercentage && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '12px',
                      right: '40px',
                      backgroundColor: '#BF490',
                      color: 'white',
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      fontSize: '14px',
                      fontWeight: '600',
                      fontFamily: 'Manrope',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}

                  >

                    {product.discountPercentage} OFF
                  </div>
                )}

                <img
                  src={product.image}
                  alt={product.name}
                  style={{
                    width: '100%',
                    height: '160px',
                    objectFit: 'contain',
                    borderRadius: '20px',
                    marginBottom: '12px',

                  }}

                />

                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    fontFamily: 'Manrope',
                    marginBottom: '8px',
                    color: '#010642',
                    fontSize: '18px',
                    fontStyle: 'normal', // "Bold" is not a valid font-style, use fontWeight instead
                    textAlign: 'center',
                    fontFamily: 'Manrope',
                    fontWeight: 700,
                    lineHeight: 'normal',
                    fontStretch: 'normal',
                    textDecoration: 'none'
                  }}
                >
                  {product.name}
                </div>

                <div style={{ marginBottom: '12px' }}>
                  {product.specialPrice ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div
                        style={{
                          fontSize: '15px',
                          fontFamily: 'Manrope',
                          fontWeight: 400,
                          color: '#010642',
                          textAlign: 'left',
                          lineHeight: 'normal',
                          padding: '4px 0',
                          display: 'inline-block',
                          textDecoration: 'line-through',
                          textDecorationColor: '#BF4904',
                          textDecorationThickness: '2px',
                          textDecorationStyle: 'solid'
                        }}
                      >
                        {product.price}
                      </div>

                      <div
                        style={{
                          fontSize: '15px',
                          color: '#BF4904',
                          fontFamily: 'Manrope',
                          fontWeight: 700,
                          textAlign: 'left',
                          lineHeight: 'normal',
                          fontStretch: 'normal',
                        }}
                      >
                        {product.specialPrice}
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        fontSize: '15px',
                        fontFamily: 'Manrope',
                        fontWeight: 400,
                        color: '#010642',
                        textAlign: 'left',
                        lineHeight: 'normal',
                        fontStretch: 'normal',
                        textDecoration: 'none'
                      }}
                    >
                      {product.price}
                    </div>
                  )}
                </div>


                <AddToCartButton
                  product={product}
                  className="add-to-cart-button"
                  style={{ backgroundColor: '#C37559', color: '#fff', alignSelf: 'center', marginTop: '12px' }}
                >
                  Add to Cart
                </AddToCartButton>
              </div>
            ))}
          </div>


        </div>

        {/* Products*/}
        <div
          style={{


            textAlign: 'center',
            borderRadius: '30px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
          }}

        >
          {loading ? (<div>Loading...</div>) : (<Medicament allMedicaments={medicaments} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} setShowPartnerDialog={setShowPartnerDialog} loading={loading} />)}
        </div>

        {/*  We guarantee high-quality service */}
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            padding: '24px',
            position: 'relative',
            display: 'grid',
            gap: '60px'
          }}
        >
          {/* Title */}
          <h2
            className='pharmacy-text108Custom'
          >
            We guarantee high-quality service
          </h2>

          {/* Horizontal Row of 3 Divs */}
          <div
            className="qualities-row"
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '24px',
              mt: '20px',
            }}
          >
            <div
              className="responsive-container"
            >
              {/* Image */}
              <img
                src="/external/vector1532-jyv3.svg"
                alt="Description"
                className="qualityImageFastDrive-style"
              />

              {/* Title Text */}
              <span
                className="qualityMainText"
              >
                Fast delivery
              </span>

              {/* Subtitle Text */}
              <span
                style={{
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 400, // Regular
                  fontSize: '18px',
                  lineHeight: '60px',
                  color: '#020742',
                  textAlign: 'center',
                }}
              >
                Home delivery within 48 to 72 hours
              </span>
            </div>

            <div
              className="responsive-container"
            >
              {/* Image */}
              <img
                src="/external/vector1532-xri.svg"
                alt="Description"
                className="qualityImageSecurePayment-style"
              />

              {/* Title Text */}
              <span className="qualityMainText">
                {isMobile ? 'secure payment' : '100% secure payment'}
              </span>

              {/* Subtitle Text */}
              <span
                style={{
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 400, // Regular
                  fontSize: '18px',
                  lineHeight: '60px',
                  color: '#020742',
                  textAlign: 'center',
                }}
              >
                Payment on delivery
              </span>
            </div>

            <div
              className="responsive-container"
            >
              {/* Image */}
              <img
                src="/external/star31532-8xfi.svg"
                alt="Description"
                className="qualityImageFreeDelivery-style"
              />

              {/* Title Text */}
              <span
                className="qualityMainText"
              >
                Free delivery
              </span>

              {/* Subtitle Text */}
              <span
                style={{
                  fontFamily: 'Manrope, sans-serif',
                  fontWeight: 400, // Regular
                  fontSize: '18px',
                  lineHeight: '60px',
                  color: '#020742',
                  textAlign: 'center',
                }}
              >
                From 190 DT of purchases
              </span>
            </div>

          </div>
        </div>

        {/* blogs  */}
        <style>{`
          /* Improved blog section styles with clamped preview and fade overlay */
          .about-us-section-7 { padding: 80px 0; background-color: #FFFFFF; }
          .about-us-section-7-content { max-width: 1400px; margin: 0 auto; padding: 0 20px; }
          .about-us-section-7-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 40px; }
          .about-us-section-7-title { font-size: 2rem; font-weight: 700; font-family: Playfair Display; color: var(--color--title, #131b5c); margin: 12px 0; }
          .blogs-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
          .blog-card { background: #fff; border-radius: 12px; overflow: hidden; transition: transform 0.12s ease; position: relative; }
          .blog-card:hover { transform: translateY(-2px); }
          .blog-image { width: 100%; height: 180px; overflow: hidden; position: relative; }
          .blog-image img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s ease; }
          .blog-card:hover .blog-image img { transform: scale(1.05); }
          .blog-category { position: absolute; top: 20px; left: 20px; background: rgba(255,255,255,0.9); padding: 8px 16px; border-radius: 20px; font-size: 0.9rem; font-weight: 600; color: #C37559; z-index: 1; }
          .blog-content { padding: 16px 12px; position: relative; min-height: 220px; display: flex; flex-direction: column; }
          .blog-title { font-size: 1.05rem; font-weight: 700; color: var(--color--title, #131b5c); margin: 0 0 8px 0; line-height: 1.2; font-family: "lato", sans-serif; }
          .card-preview { color: #666; font-size: 0.95rem; line-height: 1.45; margin-bottom: 10px; display: -webkit-box; -webkit-line-clamp: 4; line-clamp: 4; -webkit-box-orient: vertical; max-height: calc(1.45em * 4); overflow: hidden; text-overflow: ellipsis; position: relative; }
          .card-preview::after { content: ""; position: absolute; left: 0; right: 0; bottom: 0; height: 1.4em; pointer-events: none; background: linear-gradient(rgba(255,255,255,0), #fff 70%); }
          .read-more-link { color: #C37559; text-decoration: none; font-weight: 600; font-size: 1rem; margin: 20px 0; transition: all 0.3s ease; display: inline-block; }
          .read-more-link:hover { color: #B5674F; }
          .card-meta { margin-top: auto; padding-top: 20px; border-top: 1px solid #eee; }
          .blog-v2-feature-meta { display: flex; gap: 16px; color: #666; font-size: 0.9rem; }
          .about-us-section-7-cta { display: flex; justify-content: center; width: 100%; margin-top: 60px; }
          .about-us-section-7-btn { font-family: 'Lato'; width: auto; max-width: 100%; height: auto; padding: 1rem 2rem; background: #C37559; color: white; border: none; border-radius: 40px; font-size: clamp(1rem, 1.8vw, 1.125rem); font-weight: 600; cursor: pointer; transition: background-position 0.5s ease-out, transform 0.3s ease, box-shadow 0.3s ease; background-size: 200% auto; }
          .about-us-section-7-btn:hover { transform: translateY(-4px); background: #B5674F; }
          .about-us-section-7-btn:active { transform: translateY(-2px); }
          @media screen and (max-width: 991px) { .blogs-grid { grid-template-columns: repeat(2, 1fr); gap: 24px; } }
          @media screen and (max-width: 767px) { .about-us-section-7 { padding: 60px 0; } .about-us-section-7-title { font-size: 1.75rem; } .blogs-grid { grid-template-columns: 1fr; gap: 24px; } .blog-content { min-height: 160px; } .card-preview { -webkit-line-clamp: 3; line-clamp: 3; max-height: calc(1.5em * 3); } }
        `}</style>
        <div className="about-us-section-7" style={{ width: '100%' }}>
          <div className="about-us-section-7-content">
            <div className="about-us-section-7-header">
              <h2 className="about-us-section-7-title">Discover Our Latest Blogs</h2>
            </div>
            <div className="blogs-grid">
              {dummyBlogs
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .slice(0, 3)
                .map((blog) => (
                  <div key={blog.id} className="blog-card" onClick={() => navigate(`/blog/${blog.id}`)} style={{ cursor: 'pointer' }}>
                    <div className="blog-image">
                      <img src={blog.blogimage} alt={blog.title} />
                    </div>
                    <div className="blog-category">{blog.category}</div>
                    <div className="blog-content">
                      <h3 className="blog-title">{blog.title}</h3>
                      <div className="card-preview">
                        <ReactMarkdown>{getFirstSentence(blog.content)}</ReactMarkdown>
                      </div>
                      <a
                        href="#"
                        className="read-more-link"
                        onClick={(e) => { e.preventDefault(); navigate(`/blog/${blog.id}`); }}
                      >
                        Read more
                      </a>
                      <div className="card-meta">
                        <div className="blog-v2-feature-meta">
                          <span className="blog-v2-feature-author">{blog.author}</span>
                          <span className="blog-v2-feature-date">{formatDate(blog.date)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="about-us-section-7-cta">
              <button className="about-us-section-7-btn" onClick={() => navigate('/blogs')}>See more</button>
            </div>
          </div>
        </div>

        {/* footer image */}
        {/* <div style={{
          position: 'relative',
        }}>
          <img
            src="/external/image441534-uwxe-400h.png"
            alt="Descriptive Alt Text"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
              borderRadius: '12px',
            }}
          />
        </div> */}

        {/* Friendly Partner Notification Dialog */}
        <Dialog
          open={showPartnerDialog}
          onClose={handleDialogClose}
          aria-labelledby="partner-dialog-title"
          aria-describedby="partner-dialog-description"
          container={document.body}
          sx={{ zIndex: 1400 }}
        >
          <DialogTitle id="partner-dialog-title" sx={{ color: '#1976d2' }}>
            Notice
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="partner-dialog-description">
              You are about to add a product from <strong>a different partner</strong>.
              <br /><br />
              Please note that your shopping cart now contains items from multiple suppliers.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleDialogClose}
              color="primary"
              variant="outlined"
            >
              Understood
            </Button>
          </DialogActions>
        </Dialog>


        {showProductModal && selectedProduct && (
          <ProductModal
            onClose={handleCloseProductModal}
            onAddToCart={handleAddToCart}
            imageData={selectedProduct.imageData || selectedProduct.image}
            name={selectedProduct.name}
            subtitle={selectedProduct.variant}
            description={selectedProduct.description || 'No description available'}
            price={selectedProduct.price}
            id={selectedProduct.id}
            partner_id={selectedProduct.partner_info?.id || selectedProduct.partner_id}
            partner_info={selectedProduct.partner_info}
            setShowPartnerDialog={setShowPartnerDialog}
          />
        )}

        {/* Filter Modal */}
        {showFilterModal && (
          <FilterModal
            onClose={() => setShowFilterModal(false)}
            onApplyFilters={handleApplyFilters}
            categories={filterCategories}
            filters={filters}
          />
        )}

        {/* Healix Chatbot Icon */}
        <div
        style={{
          position: 'fixed',
          bottom: isMobile ? '-3.75rem' : '-3.75rem',
          right: isMobile ? '-3.75rem' : '-3.75rem',
          zIndex: 9999,
          cursor: 'pointer',
          animation: 'float 3s ease-in-out infinite, pulse 2s ease-in-out infinite 1s',
          pointerEvents: 'auto',
          margin: 0,
          padding: 0
        }}
        onClick={() => navigate('/healix-multi-tree-survey')}
      >
        <img
          src={healixImage}
          alt="Chatbot"
          style={{
            width: isMobile ? '9.375rem' : '11.25rem',
            height: isMobile ? '9.375rem' : '11.25rem',
            objectFit: 'contain',
            transform: isMobile ? 'scale(1.5)' : 'scale(1.6)', 
            transformOrigin: 'bottom right',
            transition: 'transform 0.3s ease-in-out',
            display: 'block',
            margin: 0,
            padding: 0
          }}
        />
      </div>
      </div>
    </div>
  )
}

export default Pharmacy
